export default "__VITE_ASSET__b30dbd02__"